<div class="loading">
  <i class="fa fa-spinner fa-spin"></i>
</div>
